module.exports = __webpack_public_path__ + "static/img/game13.dff72fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game13.jpg
// module id = bjLE
// module chunks = 1